<div class="mobile-nav l-wrapper" [ngClass]="{'_inverse': inverse, '_flow': flow}">
  <div class="mobile-nav__back">
    <button class="button-icon button-icon--th-main" (click)="onBack()">
      <i class="icomoon icomoon--arrow-left"></i>
    </button>
  </div>
  <div class="mobile-nav__title">
    <ng-content></ng-content>
  </div>
</div>
